import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { LinkedInProfile } from "common/types";

import useExcludedListLeadsMutations from "../../../../datahooks/useExcludedListLeadsMutations";
import { startListLeadsBulkAction } from "../../../../utils";

interface RemoveExcludedLeadsProps {
  listId: string;
  selectedLeads: LinkedInProfile[];
  onBack?: () => void;
  onClose: (shouldClearSelection: boolean) => void;
}

export default function RemoveExcludedLeads({
  listId,
  selectedLeads,
  onBack,
  onClose,
}: RemoveExcludedLeadsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  const { removeListExclusion } = useExcludedListLeadsMutations(listId);

  function removeExcludedLeads() {
    startListLeadsBulkAction(
      ({ urn }, abortSignal) => removeListExclusion({ urn, abortSignal }),
      selectedLeads,
      (finishedItemsCount) =>
        finishedItemsCount === selectedLeads.length
          ? "Leads removed"
          : `Removing ${finishedItemsCount}/${selectedLeads.length} leads`,
    );
    onClose(true);
  }

  return (
    <>
      <Header
        title="Remove from excluded?"
        subtitle="Once removed, they're no longer excluded from this list and sources can target them again"
        onBack={onBack}
      />

      <Footer className="justify-end">
        <Button variant="secondary-black" onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          variant="outline-danger"
          disabled={!selectedLeads.length}
          onClick={removeExcludedLeads}
        >
          Remove
        </Button>
      </Footer>
    </>
  );
}
